{
  "presence": {
    "online": "Online",
    "away": "Away",
    "offline": "Offline"
  },
  "visibility": {
    "public": "Public",
    "friends": "Friends only",
    "private": "Private"
  },
  "reports": {
    "spam": "Spam",
    "harassment": "Harassment",
    "inappropriate": "Inappropriate content",
    "impersonation": "Impersonation",
    "other": "Other"
  },
  "prefs": {
    "friend_request": "Friend requests",
    "friend_accepted": "Accepted friend requests",
    "message": "Messages",
    "reward": "Rewards",
    "market": "Market and auctions",
    "trade": "Trades",
    "free_booster": "Free boosters",
    "login_calendar": "Login calendar"
  },
  "activity": {
    "someone": "A friend",
    "levelUp": "{{who}} reached level {{level}}.",
    "achievement": "{{who}} reached “{{title}}”.",
    "achievementFallback": "an achievement",
    "rareDrop": "{{who}} got {{name}} ({{rarity}}).",
    "cardFallback": "a card",
    "rareFallback": "rare",
    "animeCompleted": "{{who}} completed {{title}}.",
    "animeFallback": "a work",
    "generic": "{{who}} did something."
  },
  "notifications": {
    "someone": "Someone",
    "friendRequest": "{{who}} sent you a friend request.",
    "friendAccepted": "{{who}} accepted your friend request.",
    "messagePreview": "{{who}}: {{preview}}",
    "message": "{{who}} sent you a message.",
    "reward": "{{title}}",
    "rewardEmpty": "New reward",
    "achievementsMany_one": "{{count}} achievement unlocked",
    "achievementsMany_other": "{{count}} achievements unlocked",
    "freeBoosters": "Your free boosters are refilled.",
    "login": "Today’s reward is ready.",
    "listingWishNamed": "{{name}} is for sale.",
    "listingWish": "A character on your wishlist is for sale.",
    "auctionWishNamed": "{{name}} is up for auction.",
    "auctionWish": "A character on your wishlist is up for auction.",
    "listingFavoriteNamed": "{{name}} is for sale.",
    "listingFavorite": "One of your favorites is for sale.",
    "auctionFavoriteNamed": "{{name}} is up for auction.",
    "auctionFavorite": "One of your favorites is up for auction.",
    "listingSoldNamed": "{{who}} bought your {{name}} card.",
    "listingSold": "{{who}} bought one of your cards.",
    "listingExpired": "Your listing for {{name}} expired.",
    "auctionBidNamed": "{{who}} bid {{amount}} Anima on {{name}}.",
    "auctionBid": "{{who}} bid {{amount}} Anima on your auction.",
    "outbidBuyout": "{{who}} bought {{name}} outright — you were refunded.",
    "outbid": "{{who}} outbid you on {{name}}.",
    "wonBuyout": "You bought {{name}} outright.",
    "won": "You won the auction for {{name}}.",
    "soldBuyout": "{{who}} bought {{name}} outright.",
    "sold": "Your auction for {{name}} has ended.",
    "unsold": "Your auction for {{name}} ended with no buyer.",
    "tradeReceived": "{{who}} offered you a trade.",
    "tradeCountered": "{{who}} countered a trade.",
    "tradeCompleted": "Trade with {{who}} completed.",
    "tradeDeclined": "{{who}} declined your trade.",
    "tradeCancelled": "Trade with {{who}} cancelled.",
    "tradeExpired": "A trade expired.",
    "staffRequest": "{{who}} asked to edit {{field}} on {{name}}.",
    "staffGranted": "You can edit {{field}} on {{name}}.",
    "staffDenied": "Editing {{field}} on {{name}} was refused.",
    "fallback": "New notification",
    "card": "a card",
    "theCard": "the card",
    "yourCard": "your card",
    "yourAuction": "your auction",
    "referralJoined": "{{who}} joined ANIDEX with your referral code.",
    "staffDeleteRequest": "{{who}} asks to delete {{name}}.",
    "staffDeleteDone": "{{name}} was deleted following your request.",
    "staffDeleteDenied": "Deleting {{name}} was refused."
  },
  "tabs": "Social sections",
  "friendsTab": "Friends",
  "atlasTab": "Atlas",
  "messagesTab": "Messages",
  "atlas": {
    "title": "Atlas",
    "intro": "Every friend’s visible collection, with the owner shown on each card.",
    "search": "Search a character, work, tag, or friend…",
    "friendFilter": "Filter by friend",
    "allFriends": "All friends",
    "rarity": "Rarity",
    "allRarities": "All",
    "noMatch": "No matches",
    "noMatchHint": "Try another filter or search.",
    "noFriends": "No friends yet",
    "noFriendsHint": "Add friends to browse their collections here.",
    "goFriends": "See friends",
    "empty": "Atlas is empty",
    "emptyHint": "Your friends don’t have visible cards yet, or their collections are private."
  },
  "friends": {
    "title": "Social",
    "intro": "Friends, requests, and recent activity.",
    "addTitle": "Add a friend",
    "username": "Player username",
    "add": "Add",
    "requests": "Requests",
    "incoming": "Request received",
    "outgoing": "Request sent",
    "accepted": "Request accepted",
    "acceptFailed": "Couldn’t accept",
    "accept": "Accept",
    "declineFailed": "Couldn’t decline",
    "decline": "Decline",
    "cancelFailed": "Couldn’t cancel",
    "nowFriends": "You’re now friends",
    "sent": "Request sent",
    "sendFailed": "Couldn’t send the request",
    "list": "Friends ({{total}})",
    "empty": "No friends yet",
    "emptyHint": "Add a player by username to get started.",
    "meta": "Level {{level}} · friends since {{date}}",
    "favorite": "Favorite",
    "messageFailed": "Couldn’t message",
    "message": "Message",
    "removeConfirm": "Remove {{username}} from your friends?",
    "removeFailed": "Couldn’t remove",
    "remove": "Remove",
    "activity": "Friend activity",
    "activityEmpty": "Nothing recent",
    "activityHint": "Your friends’ highlights will show up here."
  },
  "report": {
    "title": "Report {{name}}",
    "sent": "Report sent",
    "blocked": "{{name}} was also blocked.",
    "thanks": "Thanks, the team can look into it.",
    "failed": "Couldn’t send the report",
    "reason": "Reason",
    "details": "Details (optional)",
    "placeholder": "Describe the problem…",
    "alsoBlock": "Also block this player",
    "submit": "Send report"
  },
  "inbox": {
    "new": "New conversation",
    "search": "Search a player or message…",
    "filters": "Show conversations",
    "all": "All",
    "unread": "Unread",
    "conversations": "Your conversations",
    "shown_one": "{{count}} conversation",
    "shown_other": "{{count}} conversations",
    "unreadCount_one": "{{count}} new message",
    "unreadCount_other": "{{count}} new messages",
    "you": "You:",
    "mutedShort": "Muted",
    "caughtUp": "All caught up",
    "noMatch": "No conversations found",
    "noMatchHint": "Try another name or show all your conversations.",
    "reset": "Clear filters",
    "manage": "Manage the conversation with {{name}}",
    "title": "Messages",
    "intro": "Chat with your friends and share cards.",
    "emptyPreview": "No messages",
    "sharedCard": "Shared card: {{name}}",
    "messageFallback": "Message",
    "unmute": "Turn {{name}}’s notifications back on",
    "mute": "Mute {{name}}",
    "muted": "Conversation muted",
    "unmuted": "Notifications back on",
    "muteFailed": "Couldn’t mute",
    "delete": "Delete the conversation with {{name}}",
    "hideConfirm": "Hide this conversation?",
    "deleteFailed": "Couldn’t delete",
    "empty": "No conversations",
    "seeFriends": "See my friends",
    "emptyHint": "Start a chat from a friend’s page."
  },
  "conversation": {
    "options": "This conversation",
    "viewProfile": "View player profile",
    "messageActions": "Message actions",
    "deleteConfirm": "Delete this message? This cannot be undone.",
    "history": "Conversation history",
    "today": "Today",
    "yesterday": "Yesterday",
    "latest": "Latest messages",
    "sending": "Sending…",
    "keyboardHint": "Enter to send, Shift + Enter for a new line.",
    "reactionFailed": "Couldn’t react",
    "reactionCount_one": "{{reaction}}, {{count}} reaction",
    "reactionCount_other": "{{reaction}}, {{count}} reactions",
    "reactions": { "heart": "Heart", "fire": "Fire", "star": "Star", "spark": "Sparkles", "laugh": "Laugh", "wow": "Surprise" },
    "react": "React",
    "pickEmoji": "Choose an emoji",
    "reportMessage": "Report this message",
    "deleted": "Message deleted",
    "deleteFailed": "Couldn’t delete",
    "delete": "Delete",
    "missing": "Conversation not found",
    "back": "Back",
    "missingHint": "This chat no longer exists or was hidden.",
    "backToMessages": "Back to messages",
    "nothingToReport": "No message to report",
    "report": "Report",
    "blockConfirm": "Block {{username}}?",
    "blocked": "Player blocked",
    "blockFailed": "Couldn’t block",
    "block": "Block",
    "which": "Which message should be reported?",
    "touch": "Tap a message from {{username}}.",
    "start": "Start the conversation",
    "startHint": "Send a message or share a card from your collection.",
    "label": "Message",
    "placeholder": "Write a message…",
    "send": "Send",
    "sendFailed": "Couldn’t send"
  },
  "alerts": {
    "title": "Notifications",
    "intro": "Requests, messages, and rewards.",
    "markFailed": "Couldn’t mark everything as read",
    "markAll": "Mark all as read",
    "push": "Push notifications",
    "empty": "No notifications",
    "emptyHint": "You’re all caught up.",
    "deleteFailed": "Couldn’t delete",
    "clear": "Clear",
    "grouped": " · ×{{total}}"
  },
  "push": {
    "checking": "Checking push notifications…",
    "unsupported": "This browser doesn’t support push notifications.",
    "serverOff": "Push notifications aren’t enabled on the server yet.",
    "disabled": "Push notifications turned off",
    "enabled": "Push notifications turned on",
    "enabledHint": "You’ll get alerts even when the app is closed.",
    "denied": "Permission denied",
    "deniedHint": "Allow notifications in your browser settings.",
    "unavailable": "Push unavailable",
    "failed": "Couldn’t complete that",
    "intro": "Get messages, trades, and sales on your phone and computer, even when ANIDEX is closed.",
    "wait": "Please wait…",
    "turnOff": "Turn off push",
    "turnOn": "Turn on push notifications",
    "blocked": "Notifications are blocked by the browser."
  },
  "profile": {
    "sections": "Profile sections",
    "languageHint": "Choose your interface language.",
    "noneBlocked": "No blocked players.",
    "blockedOn": "Blocked on {{date}}",
    "unblocked": "Player unblocked",
    "unblockFailed": "Couldn’t unblock",
    "unblock": "Unblock",
    "level": "Level {{level}}",
    "xpToNext": "{{current}} / {{next}} EXP until level {{level}}",
    "balanceLabel": "Balance",
    "viewPublic": "View my public profile",
    "edit": "Edit profile",
    "admin": "Administration",
    "stats": "Statistics",
    "collection": "Collection",
    "characters": "Characters",
    "divines": "Divines obtained",
    "mythics": "Mythics obtained",
    "animes": "Works completed",
    "progress": "Progress",
    "boosters": "Boosters opened",
    "quests": "Quests completed",
    "upgrades": "Upgrades",
    "fragments": "Fragments",
    "fragmentsHeld": "In reserve",
    "fragmentsEarned": "Earned in total",
    "unlocks": "Unlocked rewards",
    "unlocksEmpty": "Titles, badges, and frames earned from achievements will show up here.",
    "blocked": "Blocked players",
    "settings": "Settings",
    "theme": "Theme",
    "themeHint": "Auto follows your device setting.",
    "sound": "Interface sounds",
    "soundHint": "Soft sounds for navigation and openings.",
    "privacy": "Profile, privacy, and notifications",
    "privacyHint": "Showcase, banner, title, visibility, and preferences.",
    "account": "Account",
    "accountLine": "{{email}} ({{status}}), member since {{date}}",
    "verified": "verified",
    "unverified": "not verified",
    "discord": "Discord",
    "discordHint": "The official server.",
    "rules": "Game rules",
    "rulesHint": "Rates, guarantees, rarities, and levels.",
    "avatar": "Avatar",
    "avatarHint": "Tap “Use as avatar” on one of your cards to change it.",
    "data": "My data",
    "dataHint": "JSON file: account, sessions, cards, ledger, messages.",
    "dataDownload": "Download",
    "dataPending": "Preparing…",
    "delete": "Delete my account",
    "deleteHint": "Erases the email, username, and collection. This cannot be undone.",
    "logout": "Sign out"
  },
  "accountDelete": {
    "title": "Delete my account",
    "intro": "This cannot be undone. ANIDEX does not restore a deleted account.",
    "consequences": [
      "The email, username, and password stop working.",
      "The collection, fragments, friends, and the text of your messages are erased.",
      "Active listings, auctions, and trades are cancelled. A live bid is returned to you, or to the bidder if you are the seller.",
      "Remaining Anima stays on an anonymous identifier. Nobody can use it. It is not money.",
      "The IP address can be used to create a new account.",
      "A message already posted on Discord is not removed."
    ],
    "policy": "Read the detail in the privacy policy",
    "password": "Password",
    "pending": "Deleting…",
    "submit": "Delete permanently"
  },
  "editor": {
    "title": "Edit profile",
    "saved": "Profile updated",
    "saveFailed": "Couldn’t save",
    "titleLabel": "Title",
    "noTitle": "No title",
    "banner": "Banner",
    "bannerDefault": "Default",
    "bannerSearch": "Search for a work…",
    "bannerEmpty": "No works match.",
    "showcase": "Showcase ({{current}}/{{slots}})",
    "showcaseEmpty": "Add favorites in your collection to put them on display.",
    "privacy": "Privacy",
    "profileVisibility": "Profile visibility",
    "collectionVisibility": "Collection visibility",
    "tradeVisibility": "Who can offer me a trade",
    "showAnima": "Show my Anima",
    "showPresence": "Show my presence",
    "allowRequests": "Allow friend requests",
    "notifications": "Notifications",
    "style": "Style",
    "styleBadges": "Badges ({{current}}/3)",
    "styleFrame": "Frame",
    "styleAvatar": "Avatar filter",
    "styleBanner": "Banner filter",
    "styleLocked": "Locked",
    "styleNone": "None"
  },
  "public": {
    "nowFriends": "You’re friends",
    "requestSent": "Request sent",
    "requestFailed": "Couldn’t send the request",
    "addFriend": "Add friend",
    "cancelRequest": "Cancel request",
    "accept": "Accept",
    "decline": "Decline",
    "messageFailed": "Couldn’t message",
    "message": "Message",
    "trade": "Offer a trade",
    "blockConfirm": "Block {{username}}?",
    "blocked": "Player blocked",
    "blockFailed": "Couldn’t block",
    "block": "Block",
    "report": "Report",
    "copyLink": "Copy link",
    "privateCollection": "Private collection",
    "privateHint": "This player doesn’t share their collection.",
    "emptyCollection": "Empty collection",
    "emptyCollectionHint": "No visible cards.",
    "compareUnavailable": "Comparison unavailable",
    "compareHint": "Sign in and make sure the collection is visible.",
    "common": "In common",
    "onlyYou": "Only you",
    "onlyThem": "Only them",
    "compareCards": "Comparison cards",
    "shared": "Shared",
    "me": "Me",
    "them": "Them",
    "noCards": "No cards",
    "noCardsHint": "Switch filters to look around.",
    "level": "Level {{level}}",
    "memberSince": "member since {{date}}",
    "anima": "Anima",
    "views": "Profile views",
    "profile": "Profile",
    "collection": "Collection",
    "compare": "Compare",
    "stats": "Statistics",
    "characters": "Characters",
    "divines": "Divines",
    "mythics": "Mythics",
    "legendaries": "Legendaries",
    "animes": "Works completed",
    "showcase": "Showcase",
    "showcaseEmpty": "No cards on display.",
    "favorites": "Favorites",
    "favoritesEmpty": "No favorites shown.",
    "unlocks": "Unlocks",
    "unlocksEmpty": "No public unlocks."
  },
  "referralTab": "Referrals",
  "referral": {
    "title": "Referrals",
    "intro": "Invite your friends: every friend who verifies their account with your code gets a starter boost, and you progress in the “Sponsor” achievement.",
    "yourCode": "Your referral code",
    "copyCode": "Copy code",
    "copyLink": "Copy link",
    "share": "Share",
    "shareText": "Join me on ANIDEX with my code {{code}} and get {{anima}} Anima + {{boosters}} Premium boosters!",
    "copied": "Copied!",
    "copyFailed": "Could not copy",
    "verifyFirst": "Verify your email address to get your referral code.",
    "welcomeTitle": "What your friend gets",
    "welcomeReward": "{{anima}} Anima and {{boosters}} Premium boosters, as soon as their email is verified.",
    "sponsorReward": "For you: every verified referral advances the “Sponsor” achievement, with endless tiers.",
    "stats": "Your referrals",
    "verified_one": "{{count}} verified referral",
    "verified_other": "{{count}} verified referrals",
    "pending_one": "{{count}} awaiting verification",
    "pending_other": "{{count}} awaiting verification",
    "achievementLink": "See the Sponsor achievement",
    "listTitle": "Latest referrals",
    "empty": "No referrals yet",
    "emptyHint": "Share your code or link to invite your friends.",
    "statusVerified": "Verified",
    "statusPending": "Pending",
    "joined": "Joined {{date}}",
    "sponsoredBy": "Your sponsor: {{username}}",
    "sponsorRewarded": "Welcome bonus received.",
    "sponsorPending": "Your welcome bonus arrives as soon as your email is verified.",
    "redeemTitle": "Got a referral code?",
    "redeemHint": "You can still enter a friend’s code for {{days}} days after signing up.",
    "redeemPlaceholder": "Sponsor code",
    "redeemSubmit": "Confirm",
    "redeemed": "Sponsor saved",
    "redeemedRewarded": "Bonus received: {{anima}} Anima and {{boosters}} Premium boosters!",
    "redeemedPending": "Verify your email to receive your bonus.",
    "redeemFailed": "Code refused"
  }
}
